import {
  useDeleteMutation,
  useInsertMutation,
  useRevalidateTables,
  useUpdateMutation,
} from '@supabase-cache-helpers/postgrest-react-query';
import { useCallback } from 'react';

import { supabaseClient } from '@/utils/supabase-client';

export function useSendInvite() {
  return useInsertMutation(
    supabaseClient.from('organisation_invite'),
    ['id'],
    '*',
    {
      revalidateTables: [{ table: 'organisation_invite' }],
    },
  );
}

export function useDeleteInvite() {
  return useDeleteMutation(
    supabaseClient.from('organisation_invite'),
    ['id'],
    '',
    {
      revalidateTables: [{ table: 'organisation_invite' }],
    },
  );
}

export function useAcceptInvite() {
  const revalidateTables = useRevalidateTables([
    { schema: 'public', table: 'organisation_member' },
    { schema: 'public', table: 'organisation_invite' },
  ]);

  return useCallback(
    async (invite_id: string) => {
      const res = await supabaseClient.rpc('accept_invite', {
        p_invite_id: invite_id,
      });

      // Revalidate the organisation members and invites tables
      await revalidateTables();

      return res;
    },
    [revalidateTables],
  );
}

export function useUpdateMember() {
  return useUpdateMutation(
    supabaseClient.from('organisation_member'),
    ['id'],
    '*',
  );
}

export function useDeleteMember() {
  return useDeleteMutation(
    supabaseClient.from('organisation_member'),
    ['id'],
    '',
  );
}
